
import { useTranslation } from "react-i18next";
import { PageContainer } from "@/components/PageContainer";
import { PageHeader } from "@/components/PageHeader";

export default function Forum() {
  const { t } = useTranslation();
  
  return (
    <PageContainer>
      <PageHeader 
        title={t("menu.forum")} 
        subtitle={t("forum.subtitle")}
      />
      {/* Content will be added in the future */}
    </PageContainer>
  );
}
